/**
 * @property {Object|null} data
 * @property {DateTime|null} date
 * @property {string|null} id
 * @property {Textbase|null} textbase
 */
export default class Snapshot {
    constructor() {
        this.data = null;
        this.date = null;
        this.id = null;
        this.textbase = null;
    }

    /**
     * Returns a boolean indicating whether this snapshot has data.
     * @return {boolean}
     */
    get isFetched() {
        return this.data !== null;
    }
}
